import WithRender from "../../templates/layouts/layout.html";

export default WithRender({});
